import { LoadContent } from '../actions/intake';

export default (store) => {
    store.dispatch(LoadContent());
};
